import { render } from "./RolesComponent.vue?vue&type=template&id=6750e492"
import script from "./RolesComponent.vue?vue&type=script&lang=js"
export * from "./RolesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__